import { prismicImage } from "src/common/utils/prismic-image";
import isEmpty from "lodash/isEmpty";

export const buildImage = (props, item) => {
  let image = item.image.mobile;

  if (props.media.tabletUp) {
    image = item.image;
  }

  return prismicImage(image);
};

export const isContentBlank = (array) => isEmpty(array) || array[0].text === "";

export const hexToRgba = (hex, opacity) => {
  if (!hex) {
    return null;
  }
  if (!opacity) {
    return hex;
  }
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    return hex;
  }

  const r = result[1];
  const g = result[2];
  const b = result[3];

  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(
    b,
    16
  )}, ${opacity})`;
};
